import { render, staticRenderFns } from "./dealer-list.vue?vue&type=template&id=54324468&scoped=true&"
import script from "./dealer-list.vue?vue&type=script&lang=js&"
export * from "./dealer-list.vue?vue&type=script&lang=js&"
import style0 from "./dealer-list.vue?vue&type=style&index=0&id=54324468&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54324468",
  null
  
)

export default component.exports